import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { SITE } from "../data/sampleData";

const LINKS = [
    { to: "/", label: "Home" },
    { to: "/exams", label: "Exams" },
    { to: "/panel", label: "Panel" },
    { to: "/book", label: "Book" },
    { to: "/report", label: "Sample Report" },
    { to: "/about", label: "About & Contact" },
];

export const Footer = () => (
    <footer className="bg-pine-deep text-paper" data-testid="footer">
        <div className="wrap pt-20 pb-10 md:pt-28">
            <div className="grid gap-12 md:grid-cols-12">
                <div className="md:col-span-6">
                    <div className="flex items-center gap-3">
                        <Logo className="h-9 w-9" />
                        <span className="font-display text-2xl">The Panel Room</span>
                    </div>
                    <p className="mt-6 max-w-sm text-sm leading-relaxed text-paper/60">
                        {SITE.tagline} Every name, question and score on this
                        site is sample content, ready for you to replace.
                    </p>
                </div>

                <div className="md:col-span-3">
                    <p className="text-[10px] font-medium uppercase tracking-[0.22em] text-brass">
                        Explore
                    </p>
                    <ul className="mt-5 space-y-3">
                        {LINKS.map((l) => (
                            <li key={l.to}>
                                <Link
                                    to={l.to}
                                    data-testid={`footer-link-${l.label.toLowerCase().replace(" & ", "-").replace(" ", "-")}`}
                                    className="text-sm text-paper/75 transition-colors duration-300 hover:text-brass"
                                >
                                    {l.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="md:col-span-3">
                    <p className="text-[10px] font-medium uppercase tracking-[0.22em] text-brass">
                        Contact
                    </p>
                    <ul className="mt-5 space-y-3 text-sm text-paper/75">
                        <li>{SITE.contact.email}</li>
                        <li>WhatsApp · {SITE.contact.whatsapp}</li>
                        <li>{SITE.contact.hours}</li>
                    </ul>
                </div>
            </div>

            <p
                className="mt-16 font-display leading-none tracking-tight text-paper/90 md:mt-24"
                style={{ fontSize: "clamp(2.75rem, 9vw, 7rem)" }}
            >
                Face the board.
            </p>

            <div className="mt-10 flex flex-col gap-2 border-t border-paper/15 pt-6 text-xs text-paper/45 sm:flex-row sm:items-center sm:justify-between">
                <p>© {new Date().getFullYear()} The Panel Room. All content is sample content.</p>
                <p>Replace it in one file — src/data/sampleData.js</p>
            </div>
        </div>
    </footer>
);
